"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = ["Ergonomische Arbeitsplätze für volle Konzentration", "Highspeed-WLAN und modernste Technik", "Kostenlose Parkplätze direkt vor der Tür"];
export default function WillkommenBeiJenniferEckstein() {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="89354" id="dein-neuer-arbeitsplatz-in-kassel" className="relative w-full bg-[#EEEEEE] px-3 sm:px-4 pt-3 pb-3">
  <div className="relative mx-auto w-full min-h-[90vh] rounded-[1rem] overflow-hidden">
    {/* Video Background */}
    <video ref={videoRef} className="absolute inset-0 h-full w-full object-cover" autoPlay muted loop playsInline preload="auto">
      <source src="https://perfect-duck.10web.cloud/wp-content/uploads/2026/04/Coworking-Reel-2.mp4" type="video/mp4" />
    </video>
    {/* Subtle Overlay */}
    <div className="absolute inset-0 bg-black/10 z-10" />
    {/* Content */}
    <div ref={textRef} className={`relative z-20 flex items-end min-h-[90vh] pt-24 sm:pt-0 transition-all duration-1000 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-16">
        {/* Glass Card */}
        <div className="backdrop-blur-xl bg-white/20 border border-white/30 rounded-2xl p-10 md:p-14 max-w-3xl shadow-2xl">
          <span className="mb-5 inline-block rounded-full bg-white/20 backdrop-blur-sm border border-white/30 px-5 py-2 text-sm font-semibold uppercase tracking-widest text-[#FF6F61]">
            Coworking Space in Kassel
          </span>
          <h1 className="mb-6 font-sans text-4xl font-bold leading-[1.05] tracking-tighter text-white sm:text-5xl lg:text-6xl xl:text-7xl">
            Arbeit verdient einen besseren Ort.
          </h1>
          <p className="mb-8 text-base md:text-lg leading-relaxed text-white/80 max-w-lg">
            Nicht das Homeoffice. Nicht das Café. Sondern ein Raum, der für dich gemacht ist. Coworking Kassel ist dein Arbeitsplatz in Lohfelden, mit allem, was du brauchst.
          </p>
          <ul className="mb-10 flex flex-col gap-3">
            {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                <CircleCheck className="mt-0.5 size-6 shrink-0 text-[#FF6F61]" />
                <span className="font-sans text-lg text-white/90">{benefit}</span>
              </li>)}
          </ul>
          <div className="flex flex-col sm:flex-row flex-wrap gap-4">
            <Link to="/kontakt" className="w-full sm:w-auto">
              <Button size="lg" className="h-14 w-full sm:w-auto rounded-full bg-[#FF6F61] !px-14 text-base font-semibold text-white shadow-lg transition-all hover:bg-[#FF6F61]/90 hover:shadow-xl hover:-translate-y-0.5">
                Kontakt aufnehmen
              </Button>
            </Link>
            <Button variant="ghost" size="lg" className="h-14 w-full sm:w-auto rounded-full backdrop-blur-md bg-white/10 border border-white/20 !px-14 text-base font-semibold text-white transition-all hover:bg-white/20" onClick={() => {
                document.getElementById('das-erwartet-dich')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }}>
              Mehr erfahren
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>;
}